var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.757,
    height: 64.845,
    viewBox: "0 0 55.757 64.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(-808.056 -1242.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 58.393,
    height: 8.224,
    rx: 4.112,
    transform: "translate(808.056 1284.269) rotate(-45)",
    fill: "#d5ecd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 58.393,
    height: 8.224,
    rx: 4.112,
    transform: "translate(812.382 1293.139) rotate(-45)",
    fill: "#439a63"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 58.393,
    height: 8.224,
    rx: 4.112,
    transform: "translate(816.708 1302.009) rotate(-45)",
    fill: "#08652a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group2.a09a965282ccb4554e0473de044ca9be.svg";
export { ForwardRef as ReactComponent };